<div [ngStyle]="{ width: width }">
    <on-select-manager
        (managerChanged)="changeManager(params.data)"
        [(ngModel)]="params.data.ManagerId"
        [allEmployees]="allEmployees"
        [isOpen]="true"
    >
    </on-select-manager>
</div>
